import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RegistroPersonasEmpresasLibModule } from '@rpe/registro-personas-empresas-lib';
import { SharedModule } from '../../shared/shared.module';

import { EmpresasRoutingModule } from './empresas-routing.module';
import { EntityMisEmpresasFormContainerComponent } from './entity-mis-empresas/components/entity-mis-empresas-form-container/entity-mis-empresas-form-container.component';
import { PersonaFisicaFormComponent } from './entity-personas-fisica/persona-fisica-form/persona-fisica-form.component';
import { PersonaJuridicaFormComponent } from './entity-personas-juridica/persona-juridica-form/persona-juridica-form.component';
import { EntityRegistroEmpresaFormContainerComponent } from './entity-registro-empresa/components/entity-registro-empresa-form-container/entity-registro-empresa-form-container.component';
import { VistaDatosMiEmpresaContainerComponent } from './vista-datos-mi-empresa/components/vista-dato-mi-empresa-container/vista-datos-mi-empresa-container.component';
import { VistaMisEmpresasContainerComponent } from './vista-mis-empresas/components/vista-mis-empresas-container/vista-mis-empresas-container.component';
import { VistaRegistroEmpresaContainerComponent } from './vista-registro-empresa/components/vista-registro-empresa-container/vista-registro-empresa-container.component';
import { PersonaModule } from '../persona/persona.module';
import { UbicacionesModule } from '../ubicaciones/ubicaciones.module';
import { ActividadesModule } from '../actividades/actividades.module';
import { RegistroIntegranteFormComponent } from './entity-registro-empresa/components/registro-integrante-form/registro-integrante-form.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { RegistroIntegranteUpdateFormComponent } from './entity-registro-empresa/components/registro-integrante-update-form/registro-integrante-update-form.component';
import { EntityMisEmpresasDatosDetailComponent } from './vista-datos-mi-empresa/components/entity-mis-empresas-datos-detail/entity-mis-empresas-datos-detail.component';
import { VistaMisIntegrantesComponent } from './vista-mis-integrantes/components/vista-mis-integrantes/vista-mis-integrantes.component';
import { VistaMisIntegrantesContainerComponent } from './vista-mis-integrantes/components/vista-mis-integrantes-container/vista-mis-integrantes-container.component';
import { VistaMisDepositosDependenciasContainerComponent } from './vista-depositos-dependencias/components/vista-mis-depositos-dependencias-container/vista-mis-depositos-dependencias-container.component';
import { VistaMisDepositosDependenciasComponent } from './vista-depositos-dependencias/components/vista-mis-depositos-dependencias/vista-mis-depositos-dependencias.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ContactosModule } from '../contactos/contactos.module';
import { DatosMiEmpresaContainerComponent } from './vista-datos-mi-empresa/components/datos-mi-empresa-container/datos-mi-empresa-container.component';
import { AcreditacionEmpresaFormComponent } from './acreditacion-empresa/features/acreditacion-empresa/components/acreditacion-empresa-form/acreditacion-empresa-form.component';
import { AcreditacionEmpresaFormContainerComponent } from './acreditacion-empresa/features/acreditacion-empresa/components/acreditacion-empresa-form-container/acreditacion-empresa-form-container.component';
import { AcreditacionEmpresaComponent } from './vista-datos-mi-empresa/components/acreditacion-empresa/acreditacion-empresa.component';
import { GisModule } from '../../gis/gis.module';
import { EffectsModule } from '@ngrx/effects';
import { EmpresaDGIEffects } from './empresas-dgi/empresas-dgi.effects';

@NgModule({
  declarations: [
    EntityMisEmpresasFormContainerComponent,
    PersonaFisicaFormComponent,
    PersonaJuridicaFormComponent,
    EntityRegistroEmpresaFormContainerComponent,
    VistaDatosMiEmpresaContainerComponent,
    VistaMisEmpresasContainerComponent,
    VistaRegistroEmpresaContainerComponent,
    RegistroIntegranteFormComponent,
    RegistroIntegranteUpdateFormComponent,
    EntityMisEmpresasDatosDetailComponent,
    VistaMisIntegrantesComponent,
    VistaMisIntegrantesContainerComponent,
    VistaMisDepositosDependenciasContainerComponent,
    VistaMisDepositosDependenciasComponent,
    DatosMiEmpresaContainerComponent,
    AcreditacionEmpresaFormComponent,
    AcreditacionEmpresaFormContainerComponent,
    AcreditacionEmpresaComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    SharedModule,
    ActividadesModule,
    PersonaModule,
    RegistroPersonasEmpresasLibModule,
    UbicacionesModule,
    EmpresasRoutingModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    ContactosModule,
    GisModule,
    EffectsModule.forFeature([EmpresaDGIEffects]),
  ],
  exports: [
    EntityMisEmpresasFormContainerComponent,
    PersonaFisicaFormComponent,
    PersonaJuridicaFormComponent,
    EntityRegistroEmpresaFormContainerComponent,
    VistaDatosMiEmpresaContainerComponent,
    VistaMisEmpresasContainerComponent,
    VistaRegistroEmpresaContainerComponent,
    DatosMiEmpresaContainerComponent
  ]
})
export class EmpresasModule { }
